import React from 'react';
import PropTypes from 'prop-types';
import Content from './content';
import DefaultDisclaimer from './compliance-disclaimers/default-advisor-disclaimer';
import FidelityGoDisclaimer from './compliance-disclaimers/fidelity-go-disclaimer';
import MarcusInvestDisclaimer from './compliance-disclaimers/marcus-invest-advisor-disclaimer';
import MerrillEdgeDisclaimer from './compliance-disclaimers/merrill-edge-disclaimer';
import MerrillEdgeIRADisclaimer from './compliance-disclaimers/merrill-edge-ira-disclaimer';
import PCDisclaimer from './compliance-disclaimers/personal-capital-disclaimer';
import StashDisclaimer from './compliance-disclaimers/stash';
import WealthfrontDisclaimer from './compliance-disclaimers/wealthfront-advisor-disclaimer';

const disclaimerMap = {
  standard: DefaultDisclaimer,
  wealthfront: WealthfrontDisclaimer,
  marcusinvest: MarcusInvestDisclaimer,
  personalcapital: PCDisclaimer,
  merrilledge: MerrillEdgeDisclaimer,
  merrilledgeira: MerrillEdgeIRADisclaimer,
  fidelitygo: FidelityGoDisclaimer,
  stash: StashDisclaimer,
};

const AdvisoryInterstitial = (props) => {
  const Disclaimer = disclaimerMap[props.disclaimer] || disclaimerMap.standard;
  return (
    <div className="redirect-holder">
      <Content {...props} />
      {(props.secName || props.disclaimer === 'merrilledgeira') && (
        <Disclaimer {...props} />
      )}
    </div>
  );
};

AdvisoryInterstitial.propTypes = {
  secName: PropTypes.string,
  tradeName: PropTypes.string,
  advLink: PropTypes.string,
  href: PropTypes.string,
  disclaimer: PropTypes.string,
};

AdvisoryInterstitial.defaultProps = {
  disclaimer: 'standard',
};

export default AdvisoryInterstitial;
